import React from 'react';
import { PassSC, Pass, ChangePasswords, FormDiv } from './ChangePassword.style';
import { Trans, useTranslation } from 'react-i18next';
import { Highlight } from 'components/vm-deployment/components';
import { change_password_form } from 'constants/account-profile';
import { Grid } from '@mui/material';
import Input from 'components/input';
import { Formik, Form } from 'formik';
import { changePasswordInitialValues, changePasswordValidationSchema } from 'constants/account-profile';
import CustomButton from 'components/common/custom-button';
import 'components/input/input.css';
import { validationsTooltip, validation } from 'utils/password-validation-tooltip';
import { Heading } from 'components/user-management/Heading';
import { P } from 'components/reusable-css';
import { Label, Margin } from 'assets/css/common-styles';

const ChangePassword = ({ username, width }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={changePasswordInitialValues('')}
      validationSchema={changePasswordValidationSchema}
      onSubmit={async () => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched }) => (
        <Form>
          <PassSC>
            <Pass>
              <Heading>
                <Trans i18nKey="account/profile.string1" components={{ highlight: <Highlight /> }} />
              </Heading>
              <ChangePasswords>
                <P>{t('account/profile.string2')}</P>
                <FormDiv>
                  <Grid container>
                    <Grid xs={6} sm={3} lg={3} xl={2}>
                      <Label>{t('account/profile.string3')}</Label>
                    </Grid>
                    <Grid xs={6} sm={2} lg={2} xl={3}>
                      <Margin>{username}</Margin>
                    </Grid>
                  </Grid>
                  {change_password_form.map((item, i) => (
                    <Grid key={item.name} container>
                      <Grid xs={12} sm={3} lg={3} xl={2}>
                        <Label>{t(item.lang)}</Label>
                      </Grid>
                      <Grid xs={12} sm={10} md={6} lg={5} xl={3}>
                        <Input
                          styling={width}
                          type={item.type}
                          className="custom_inputs"
                          name={item.name}
                          value={values[item.name]}
                          placeholder={t(item.placeholder_lang)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors[item.name]}
                          touched={touched[item.name]}
                          dataTooltip={i != 0 && validationsTooltip(values[item.name])}
                        />
                      </Grid>
                    </Grid>
                  ))}
                </FormDiv>
                <CustomButton
                  disabled={
                    !validation(values.new_password) ||
                    !validation(values.new_password_confirm) ||
                    errors.new_password_confirm ||
                    !values.original_password
                  }
                  type="submit"
                  buttonStyles={{ padding: ' 9px 55px' }}
                />
              </ChangePasswords>
            </Pass>
          </PassSC>
        </Form>
      )}
    </Formik>
  );
};
export default ChangePassword;
